module.exports = __webpack_public_path__ + "img/career-img-svg-2.e9e6d545.svg";